module.exports = __webpack_public_path__ + "static/custom-tooltips-0876b2833d28bc8291cfbac46e300208.png";